// extracted by mini-css-extract-plugin
module.exports = {"title":"JobItemContent_title__2ozbm","label":"JobItemContent_label__3J42E","attributes":"JobItemContent_attributes__kh0jg","sending":"JobItemContent_sending__148lo"};